export const getEnv = () => {
  switch (window.location.host) {
    case 'carrier.yolda.com':
      return 'production'
    case 'carrier.alfa.yolda.io':
      return 'alfa'
    case 'carrier.beta.yolda.io':
      return 'beta'
    case 'carriere2e.alfa.yolda.io':
      return 'e2e'
    default:
      return 'alfa'
  }
}

const alfa = {
  url: 'https://carrier.alfa.yolda.io',
  apiUrl: 'https://alfa.api.yolda.io',
  metaUrl: 'https://alfa.api.yolda.io/metadata/v1',
  tenantUrl: 'https://alfa.api.yolda.io/tenants/v1',
  tripLegsUrl: 'https://alfa.api.yolda.io/tripLegs/v1',
  barcodeUrl: 'https://alfa.api.yolda.io/barcodes/v1',
  barcodeHubUrl: 'https://alfa.api.yolda.io/barcodes/v1/hub',
  tripHubUrl: 'https://alfa.api.yolda.io/trips/v1/hub',
  tripUrl: 'https://alfa.api.yolda.io/trips/v1',
  loadsUrl: 'https://alfa.api.yolda.io/loads/v1',
  barcodeHubScan: 'https://alfa.api.yolda.io/barcodes/v1/hub',
  costUrl: 'https://alfa.api.yolda.io/costs/v1',
  paymentUrl: 'https://alfa.api.yolda.io/carrierPayments/v1',
  locationUrl: 'https://alfa.api.yolda.io/locations/v1',
  validatorUrl: 'https://alfa.api.yolda.io/validator/v1',
  translationUrl: 'https://static.alfa.yolda.io',
  dataExtractionUrl: 'https://alfa.api.yolda.io/dataExtraction/v1',
  GoogleMapsApi: 'AIzaSyB1RG8pku8GFKEOmXsztzWAJV_ntz7cNQg',
  MixPanelToken: '4da2f5269655c9e5a4b79afc9919e145',
  OneSignalAppId: '1cf8a3fe-96ab-4dc8-bf57-ab626c1cd798',
  CloudFlareTurnsTileKey: '0x4AAAAAAAD4KvA4nAebtuUb',
  HubspotPanelId: '25492827',
  HubspotFormId: '1e67def8-848d-4233-9418-f7f83d219e81',
  Sentry: {
    dsn: 'https://f9d923d3a5b94bac9e3f03c4be45d9a7@o448351.ingest.sentry.io/6615058',
    projectName: 'carrier-web',
  },
  APIKey: 'LIRnr1ecIR3jItY8EIis39t5F3c8VyTuxEuXZ4r7',
  carrierMobileWebViewAPIKey: 'JcvHjDFyRDa0qx4olgunD4vMWEkJ32nS5JPTHpAJ',
  aws: {
    identityPoolId: 'eu-central-1:5e38a91a-2d2d-48f1-9b3e-7b34cf028453',
    region: 'eu-central-1',
    identityPoolRegion: 'eu-central-1',
    userPoolId: 'eu-central-1_ZpEqFBNif',
    userPoolWebClientId: '11912atahjt25l5ijed5747ia5',
    mandatorySignIn: false,
    authenticationFlowType: 'CUSTOM_AUTH',
  },
}

const e2e = alfa

const beta = {
  url: 'https://carrier.beta.yolda.io',
  apiUrl: 'https://beta.api.yolda.io',
  metaUrl: 'https://beta.api.yolda.io/metadata/v1',
  tenantUrl: 'https://beta.api.yolda.io/tenants/v1',
  tripLegsUrl: 'https://beta.api.yolda.io/tripLegs/v1',
  barcodeUrl: 'https://beta.api.yolda.io/barcodes/v1',
  barcodeHubUrl: 'https://beta.api.yolda.io/barcodes/v1/hub',
  tripHubUrl: 'https://beta.api.yolda.io/trips/v1/hub',
  tripUrl: 'https://beta.api.yolda.io/trips/v1',
  loadsUrl: 'https://beta.api.yolda.io/loads/v1',
  barcodeHubScan: 'https://beta.api.yolda.io/barcodes/v1/hub',
  costUrl: 'https://beta.api.yolda.io/costs/v1',
  paymentUrl: 'https://beta.api.yolda.io/carrierPayments/v1',
  validatorUrl: 'https://beta.api.yolda.io/validator/v1',
  translationUrl: 'https://static.beta.yolda.io',
  dataExtractionUrl: 'https://beta.api.yolda.io/dataExtraction/v1',
  GoogleMapsApi: 'AIzaSyB1RG8pku8GFKEOmXsztzWAJV_ntz7cNQg',
  MixPanelToken: '4da2f5269655c9e5a4b79afc9919e145',
  OneSignalAppId: '29290b6a-2ecd-40c2-8b29-37035a230b6a',
  CloudFlareTurnsTileKey: '0x4AAAAAAAD4KvA4nAebtuUb',
  HubspotPanelId: '25492827',
  HubspotFormId: '30761656-e8e8-4782-b53f-a81207367250',
  Sentry: {
    dsn: 'https://f9d923d3a5b94bac9e3f03c4be45d9a7@o448351.ingest.sentry.io/6615058',
    projectName: 'carrier-web',
  },
  APIKey: 'Rs3F6VuyPo3qvZ0PwEgD06YxaBZTFegX5uE07VwP',
  carrierMobileWebViewAPIKey: 'KU7bi4gFol49G2ltWJHKl9gpn5mKCCiI6NHoHa6E',
  aws: {
    identityPoolId: 'eu-central-1:7bc64f38-94ea-4c58-ac81-2e647aee5d15',
    region: 'eu-central-1',
    identityPoolRegion: 'eu-central-1',
    userPoolId: 'eu-central-1_OlB8W7PpW',
    userPoolWebClientId: '4u3bafkvhtfjdsufg9tvjo62fl',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
}

const production = {
  url: 'https://carrier.yolda.com',
  apiUrl: 'https://api.yolda.com',
  metaUrl: 'https://api.yolda.com/metadata/v1',
  tenantUrl: 'https://api.yolda.com/tenants/v1',
  tripLegsUrl: 'https://api.yolda.com/tripLegs/v1',
  barcodeUrl: 'https://api.yolda.com/barcodes/v1',
  barcodeHubUrl: 'https://api.yolda.com/barcodes/v1/hub',
  tripHubUrl: 'https://api.yolda.com/trips/v1/hub',
  tripUrl: 'https://api.yolda.com/trips/v1',
  loadsUrl: 'https://api.yolda.com/loads/v1',
  barcodeHubScan: 'https://api.yolda.com/barcodes/v1/hub',
  costUrl: 'https://api.yolda.com/costs/v1',
  paymentUrl: 'https://api.yolda.com/carrierPayments/v1',
  locationUrl: 'https://api.yolda.com/locations/v1',
  validatorUrl: 'https://api.yolda.com/validator/v1',
  translationUrl: 'https://static.yolda.com',
  dataExtractionUrl: 'https://api.yolda.com/dataExtraction/v1',
  GoogleMapsApi: 'AIzaSyAYs6BiUkHS7OUGaboCfw4DYDkSEkulaBo',
  MixPanelToken: '74381a3412faf75e8efad51dcc49d4d4',
  OneSignalAppId: '600eee90-f506-46cc-9664-3b7d71561891',
  CloudFlareTurnsTileKey: '0x4AAAAAAAD4RfqneEwjn3Cn',
  HubspotPanelId: '8778030',
  HubspotFormId: '30761656-e8e8-4782-b53f-a81207367250',
  Sentry: {
    dsn: 'https://f9d923d3a5b94bac9e3f03c4be45d9a7@o448351.ingest.sentry.io/6615058',
    projectName: 'carrier-web',
  },
  APIKey: 'wlipxVafM6a7ELGbbkkmK5IpISd3B9Me1hkORFkN',
  carrierMobileWebViewAPIKey: 'D3PvL8Jo7l9m34VPmPbJg118ACe30FeH5ZK8v1Bw',
  aws: {
    identityPoolId: 'eu-central-1:c73cf6cf-e117-4e5e-8107-637a4720bd0b',
    region: 'eu-central-1',
    identityPoolRegion: 'eu-central-1',
    userPoolId: 'eu-central-1_rchHEH8TK',
    userPoolWebClientId: '4pfg0m16ts5i6rsb2co1b9qu2s',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  HotjarId: 3124784,
}

const config: any = {
  alfa,
  e2e,
  beta,
  production,
}

export default { ...config[getEnv()] }
